import { AbstractTableToolsPanel } from "./headingPanel/AbstractTableToolsPanel";
import { Component } from "../../base/Component";
import {
    EnabledInTableHeader, EnabledInTableHeaderMethod, EnabledInTableHeaderValues
} from "./headingPanel/customTools/EnabledInTableHeader";
import { Table } from "./Table";

export class EnabledInTableHeaderTester {
    /**
     * If the component is in a table's header (in one of the tool panels), see if it should be disabled based on how
     * many rows are currently selected in the table.
     */
    public static shouldBeEnabled(component: Component): boolean {
        if (component.specialParent instanceof AbstractTableToolsPanel && component._designer == null) {
            const tableToolsPanel = component.specialParent as AbstractTableToolsPanel;
            const testMethod = this.resolveMethod(component.enabledInTableHeader);
            return testMethod?.(component, tableToolsPanel.table);
        }
        return true;
    }

    private static resolveMethod(value: EnabledInTableHeader): EnabledInTableHeaderMethod {
        // If a custom test function has been provided, use that
        if (typeof value === "function") {
            return value;
        }
        // Otherwise, use the standard testing method for the provided enum value
        return this.getStandardMethod(value);
    }

    private static getStandardMethod(value: EnabledInTableHeaderValues): EnabledInTableHeaderMethod {
        switch (value) {
            case EnabledInTableHeaderValues.ALWAYS:
                return this.testAlways;
            case EnabledInTableHeaderValues.ROWS_PRESENT:
                return this.testRowsPresent;
            case EnabledInTableHeaderValues.ONE_ROW_SELECTED:
                return this.testOneRowSelected;
            case EnabledInTableHeaderValues.MULTIPLE_ROWS_SELECTED:
                return this.testMultipleRowsSelected;
            case EnabledInTableHeaderValues.ONE_OR_MORE_ROWS_SELECTED:
                return this.testOneOrMoreRowsSelected;
            default:
                return null;
        }
    }

    private static readonly testAlways = (_component: Component, _table: Table): boolean => {
        return true;
    }

    private static readonly testRowsPresent = (_component: Component, table: Table): boolean => {
        return table.displayedRowCount > 0;
    }

    private static readonly testOneRowSelected = (_component: Component, table: Table): boolean => {
        return table.selectedRowCount === 1;
    }

    private static readonly testMultipleRowsSelected = (_component: Component, table: Table): boolean => {
        return table.selectedRowCount > 1;
    }

    private static readonly testOneOrMoreRowsSelected = (_component: Component, table: Table): boolean => {
        return table.selectedRowCount >= 1;
    }
}
